import React from "react";
import "./footer.css";

const Footer = () => {
  return (
    <div className="footer">
      <div className="justify-content-center d-flex flex-column align-items-center gap-3">
        <div className="d-flex gap-4">
          <a href="https://www.instagram.com/silentexchange.store" target="_blank" rel="noopener noreferrer" className="footer-social-link">
            <i className="fab fa-instagram"></i>
          </a>
          <a href="https://www.facebook.com/profile.php?id=61575060797727" target="_blank" rel="noopener noreferrer" className="footer-social-link">
            <i className="fab fa-facebook"></i>
          </a>
          <a href="https://www.threads.net/@silentexchange.store" target="_blank" rel="noopener noreferrer" className="footer-social-link">
            <i className="fab fa-threads"></i>
          </a>
          <a href="https://www.tiktok.com/@silentexchange.store" target="_blank" rel="noopener noreferrer" className="footer-social-link">
            <i className="fab fa-tiktok"></i>
          </a>
        </div>
        <p className="footer-copy">© {new Date().getFullYear()} Silent Exchange. All rights reserved.</p>
      </div>
    </div>
  );
};

export default Footer;